export var VariantType;
(function (VariantType) {
    VariantType["Print"] = "print";
    VariantType["WebPreview"] = "webPreview";
    VariantType["Thumb"] = "thumb";
    VariantType["BackgroundRemoved"] = "backgroundRemoved";
    VariantType["Sharpened"] = "sharpened";
    VariantType["Embroidery"] = "embroidery";
    VariantType["Monochrome"] = "monochrome";
    VariantType["Preview"] = "preview";
})(VariantType || (VariantType = {}));
//# sourceMappingURL=variantsType.js.map